export function SentinelComment(lbNoteComment) {
    this.id = lbNoteComment.id;
    this.noteId = lbNoteComment.noteId;
    this.created = moment(lbNoteComment.created).toDate();
    this.comment = lbNoteComment.comment;
    this.user = lbNoteComment.createdBy.firstName + ' ' + lbNoteComment.createdBy.lastName;
};